import React, { useState, useEffect, useMemo } from "react";
import { Col, Row, Modal, ModalBody, Input, Label, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import { getPhotoUrl } from "../../../config";
import defaultUserImg from "../../../assets/images/user/img-02.jpg";
import { ToastContainer, toast } from 'react-toastify';
import { getEmployees2 } from "../../../services/userservice";
import Pagination from "../../Jobs/JobList2/Pagination";

const CandidateGridDetails = () => {
  const [modal, setModal] = useState(false);
  const [employee, setEmployee] = useState([]);
  const [perPage, setPerPage] = useState(8);
  const [documentFilter, setDocumentFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const openModal = () => setModal(!modal);

  useEffect(() => {
    const userRol = localStorage.getItem("rol");
    if (userRol !== "1") {
      toast.error("Por favor inicie sesión como empresa para continuar");
      return;
    }
    getEmployees2()
      .then((data) => setEmployee(data || []))
      .catch((error) => console.error(error));
  }, []);

  const filtered = useMemo(() => {
    if (!documentFilter.trim()) return employee;
    const q = documentFilter.trim().toLowerCase();
    return employee.filter(
      (e) => (e.identificationNumber || "").toLowerCase().includes(q)
    );
  }, [employee, documentFilter]);

  const perPageNum = perPage === "all" ? filtered.length : (perPage || 8);
  const start = (currentPage - 1) * perPageNum;
  const pageList = perPage === "all" ? filtered : filtered.slice(start, start + perPageNum);

  useEffect(() => {
    setCurrentPage(1);
  }, [documentFilter, perPage]);

  return (
    <React.Fragment>
      <ToastContainer />
      <Row className="align-items-center mb-3">
        <Col lg={5} md={6}>
          <div className="mb-2 mb-md-0">
            <label className="form-label small text-muted mb-0">Filtrar por documento (ID)</label>
            <Input
              type="text"
              placeholder="Número de documento..."
              value={documentFilter}
              onChange={(e) => setDocumentFilter(e.target.value)}
              className="form-control form-control-sm"
            />
          </div>
        </Col>
      </Row>
      <div className="list-results-bar">
        <span className="job-grid-results-text">
          {filtered.length === 0 ? "0 resultados" : `Mostrando ${start + 1} – ${Math.min(start + perPageNum, filtered.length)} de ${filtered.length}`}
        </span>
        <div className="job-grid-page-size-wrap">
          <label htmlFor="candidateGridPageSize">Candidatos por página:</label>
          <Input
            id="candidateGridPageSize"
            type="select"
            value={String(perPage)}
            onChange={(e) => setPerPage(e.target.value === "all" ? "all" : Number(e.target.value))}
            className="job-grid-page-size-select"
            aria-label="Candidatos por página"
          >
            <option value="4">4</option>
            <option value="8">8</option>
            <option value="12">12</option>
            <option value="all">Todos</option>
          </Input>
        </div>
      </div>
      <div className="candidate-list">
        {pageList.map((candidategridDetailsNew, key) => (
          <div
            key={candidategridDetailsNew.id || key}
            className="candidate-list-row card mt-2 candidate-caza-row"
          >
            <CardBody className="py-2 px-3">
              <Row className="align-items-center g-2">
                <Col xs="auto" className="flex-shrink-0">
                  <img
                    src={getPhotoUrl(candidategridDetailsNew.photo) || defaultUserImg}
                    alt=""
                    className="rounded"
                    style={{ width: "48px", height: "48px", objectFit: "cover" }}
                    onError={(e) => { e.target.src = defaultUserImg; }}
                  />
                </Col>
                <Col className="min-w-0">
                  <Link
                    to="/candidatedetails"
                    onClick={() => localStorage.setItem("employee", candidategridDetailsNew.id)}
                    className="fw-medium text-body text-decoration-none d-block candidate-name-link"
                    style={{ fontSize: "1rem" }}
                  >
                    {candidategridDetailsNew.name} {candidategridDetailsNew.lastname}
                  </Link>
                  <div className="small text-muted mt-1" style={{ fontSize: "0.8rem" }}>
                    <span className="d-inline-block me-2">Doc: {candidategridDetailsNew.identificationNumber || "—"}</span>
                    <span className="d-inline-block me-2">Contacto: {candidategridDetailsNew.phone || "—"}</span>
                    <span className="d-inline-block me-2">Ciudad: {candidategridDetailsNew.city || "—"}</span>
                    <span className="d-inline-block">Formación: {candidategridDetailsNew.studyLevel || "—"}</span>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </div>
        ))}

      <Pagination
        totalItems={filtered.length}
        pageSize={perPageNum}
        currentPage={currentPage}
        onPageChange={setCurrentPage}
      />

        <div
          className="modal fade"
          id="hireNow"
          tabIndex="-1"
          aria-labelledby="hireNow"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <Modal isOpen={modal} toggle={openModal} centered>
              <ModalBody className="p-5">
                <div className="text-center mb-4">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    Contratar Ahora
                  </h5>
                </div>
                <div className="position-absolute end-0 top-0 p-3">
                  <button
                    type="button"
                    onClick={openModal}
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="mb-3">
                  <Label for="namrFormControlInput" className="form-label">
                    Nombre de la Empresa
                  </Label>
                  <Input
                    type="text"
                    className="form-control"
                    id="namrFormControlInput"
                    placeholder="Nombre de la Empresa"
                  />
                </div>
                <div className="mb-3">
                  <Label for="emailFormControlInput" className="form-label">
                    Email
                  </Label>
                  <Input
                    type="email"
                    className="form-control"
                    id="emailFormControlInput"
                    placeholder="Email de contacto"
                  />
                </div>
                <div className="mb-4">
                  <Label
                    for="messageFormControlTextarea"
                    className="form-label"
                  >
                    Mensaje
                  </Label>
                  <textarea
                    className="form-control"
                    id="messageFormControlTextarea"
                    rows="4"
                    placeholder="Escribe tu mensaje aquí"
                  ></textarea>
                </div>
                <button type="submit" className="btn btn-primary w-100">
                  Enviar
                </button>
              </ModalBody>
            </Modal>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CandidateGridDetails;
